import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../services/api/auth/auth.service';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { logout, updateAccessToken } from '../../store/auth/auth.actions';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);
  const auth = inject(AuthService);

  const token = auth.getAccessToken();

  const cloned = token
    ? req.clone({
        setHeaders: { Authorization: `Bearer ${token ? token.accessToken : ''}` },
        withCredentials: true,
      })
    : req.clone({ withCredentials: true });

  return next(cloned).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        error.status === 401 &&
        !req.url.includes('login') &&
        !req.url.includes('/refresh') &&
        !req.url.includes('logout')
      ) {
        return auth.refreshToken().pipe(
          switchMap((res) => {
            store.dispatch(updateAccessToken({ token: res.data }));
            auth.setAccessToken(res.data);

            console.log("res",res);


            const retryReq = req.clone({
              setHeaders: { Authorization: `Bearer ${res.data.accessToken}` },
              withCredentials: true,
            });
            return next(retryReq);
          }),

          catchError((refreshErr) => {
            store.dispatch(logout());
            return throwError(() => refreshErr);
          })
        );
      }

      return throwError(() => error);
    })
  );
};
